import { defineStore } from 'pinia';
import { ref } from 'vue';
import { API_BASE_URL } from '@/utils/constants';

export const useSettingsStore = defineStore('settings', () => {
  // State
  const logoUrl = ref('/logo.png'); // Default logo
  const organizationName = ref('Intranet');
  const organizationSubtitle = ref('Organisation');
  const settings = ref(null); // Full settings object
  const loading = ref(false);

  // Actions
  async function loadSettings() {
    loading.value = true;
    try {
      // Use public endpoint that doesn't require authentication
      const response = await fetch(`${API_BASE_URL}/auth/public/settings`, {
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        const fetchedSettings = data.settings || {};

        // Store the full settings object
        settings.value = fetchedSettings;

        // Update logo URL if available - prepend API_BASE_URL for correct origin
        if (fetchedSettings.branding?.logo_url?.value) {
          const relativeUrl = fetchedSettings.branding.logo_url.value;
          logoUrl.value = `${API_BASE_URL}${relativeUrl}`;
        }

        // Update organization name if available
        if (fetchedSettings.general?.organization_name?.value) {
          organizationName.value = fetchedSettings.general.organization_name.value;
        }

        // Update organization subtitle if available
        if (fetchedSettings.general?.organization_subtitle?.value) {
          organizationSubtitle.value = fetchedSettings.general.organization_subtitle.value;
        }
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      loading.value = false;
    }
  }

  function updateLogo(url) {
    logoUrl.value = url;
  }

  function updateOrganizationName(name) {
    organizationName.value = name;
  }

  return {
    logoUrl,
    organizationName,
    organizationSubtitle,
    settings,
    loading,
    loadSettings,
    updateLogo,
    updateOrganizationName,
  };
});
